import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import { tagParser, linkParser, proxymedia, safeHtml } from '../../js/modules/utilities'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileMessage = ({ theme, title, description, tag, legalNotice, image, alt, CTA: { URL, analytics, label } }) => {
   return (
      <Fragment>
         <a
            href={URL}
            {...attributesAnalytics(analytics)}
            class="tuile-message lien-composite-before"
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}
            <div class="content">
               <div class="left-content">
                  <h3 class="h4 m-0 p-0">
                     <strong class="title" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }} />
                     <span class="subtitle" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(description)) }} />
                  </h3>
               </div>
               <div class="right-content">
                  <img src={proxymedia(image, 'saveas=webp')} alt={alt || ''} loading="lazy" />
               </div>
            </div>
            <span class="o-link-arrow">{label}</span>
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} theme={theme} index="message" />}
      </Fragment>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, theme, index }) => {
   const [legalState, setLegalState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
   }

   const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
         toggleLegals()
      }
   }

   return (
      <div class={`offerLegalNotice ${legalState ? 'openContent' : ''}`}>
         <div id={`legalNoticePanel${index}`} class={`contentLegalNotice ${theme === 'white' ? 'bg-white' : 'bg-dark'}`} aria-hidden={!legalState}>
            <span class={`closeLegal ${theme === 'white' ? 'text-dark' : 'text-white'}`} onClick={toggleLegals}>
               &times;
            </span>
            <div class={`contentText ${theme === 'white' ? 'text-dark' : 'text-white'}`}>
               {title && <div class="lead font-weight-bold" dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(linkParser(content))) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onKeyDown={handleKeyDown}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class={`icon icon-info ${theme === 'white' ? 'text-dark' : 'text-white'}`} aria-hidden="true"></span>
            <strong class={theme === 'white' ? 'text-dark' : 'text-white'}>{showButtonLabel}</strong>
         </span>
      </div>
   )
}
